export default {
  title: 'Експортувати історію чатів',
  modal: {
    title: 'Експортувати історію чатів',
    description: 'Будь ласка, зазначте період. Всі отримані і відправлені повідомлення з кожного чату будуть зібрані у звіті.<br>Не закривайте вікно, поки звіт в обробці.',
    from: 'Від',
    to: 'Кому',
    btn_submit: 'Створити звіт',
  },
  alert: {
    start: {
      title: 'Звіт в обробці',
    },
    end: {
      title: 'Звіт готовий!',
      description: 'Завантажте звіт або знайдіть його в розділі Документи',
    },
  },
}
